module.exports = __webpack_public_path__ + "static/media/zs_bg.6dcea3ca.svg";